module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_002.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_002.png
// module id = 2318
// module chunks = 5